import ModelFactory from 'business/models/ModelFactory';
import {
  AuthenticationClient,
  FileResponse,
  UserCredentialDTO,
} from 'business/models/Models';
import BaseService from './BaseService';

export default class AuthenticationService extends BaseService {
  async isAccessControlEnabled() {
    const _AuthenticationClient: AuthenticationClient = ModelFactory(
      AuthenticationClient,
      false,
      true,
    );
    return await _AuthenticationClient.isAccessControlEnabled();
  }

  async isAccessControlInitialized() {
    const _AuthenticationClient: AuthenticationClient = ModelFactory(
      AuthenticationClient,
      false,
      true,
    );
    return await _AuthenticationClient.isAccessControlInitialized();
  }

  async initializeAccessControl(grantAccessToAll: boolean) {
    const _AuthenticationClient: AuthenticationClient = ModelFactory(
      AuthenticationClient,
      false,
      true,
    );
    return await _AuthenticationClient.initializeAccessControl(grantAccessToAll);
  }

  async loginUser({ userName, pass }) {
    const userCredential = new UserCredentialDTO({ userName, pass });
    const _AuthenticationClient: AuthenticationClient = ModelFactory(
      AuthenticationClient,
      false,
      true,
    );
    const result: FileResponse = await _AuthenticationClient.authenticate(userCredential);
    return {
      ...result,
      data: result?.data && JSON.parse(await result.data.text()),
    };
  }

  async logoutUser() {
    const _AuthenticationClient: AuthenticationClient = ModelFactory(
      AuthenticationClient,
      false,
      true,
    );
    return await _AuthenticationClient.logout();
  }

  async isValidToken() {
    const _AuthenticationClient: AuthenticationClient = ModelFactory(
      AuthenticationClient,
      false,
      true,
    );
    return await _AuthenticationClient.isValidToken();
  }
}
